// 네이버 프리미엄 로그분석 계정 ID (네이버 광고 전환/유입 측정 공통)
export const NAVER_WA_ACCOUNT_ID = 's_18b7df40c71f';

type NaverWcs = {
  inflow?: () => void;
  trans?: (conv: { type: string }) => void;
};

type NaverWindow = Window & {
  wcs?: NaverWcs;
  wcs_add?: Record<string, string>;
  _nasa?: Record<string, unknown>;
  wcs_do?: (nasa?: Record<string, unknown>) => void;
};

/**
 * 네이버 lead(신청완료) 전환 측정.
 * 상담 신청이 실제로 완료된 시점에 1회 호출한다.
 * wcslog.js 는 NaverAnalytics 컴포넌트로 사이트 전체에 이미 로드되어 있다.
 */
export function trackNaverLeadConversion() {
  if (typeof window === 'undefined') return;
  const w = window as NaverWindow;
  if (!w.wcs || typeof w.wcs.trans !== 'function') return;

  if (!w.wcs_add) w.wcs_add = {};
  w.wcs_add['wa'] = NAVER_WA_ACCOUNT_ID;

  w.wcs.trans({ type: 'lead' });
}
